/* Regen-Matschhosen Theme – Warenkorb, Varianten, Filter, Größenberater, Set */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var RM = window.RM || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' } };

  /* ---------- Geld ---------- */
  function money(cents) {
    var f = RM.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (cents / 100);
    var dot = n.toFixed(2);
    var comma = dot.replace('.', ',');
    var withDelims = function (s, th, dec) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dec); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return withDelims(dot, ',', '.');
      if (k === 'amount_no_decimals') return withDelims(Math.round(n).toString(), ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(Math.round(n).toString(), '.', ',');
      if (k === 'amount_with_comma_separator') return withDelims(dot, '.', ',');
      return comma;
    }).replace(/<[^>]*>/g, '');
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2600);
  }

  /* ---------- Warenkorb ---------- */
  var layer = $('#CartLayer');
  var onCartPage = document.body.classList.contains('template-cart');

  function openCart() {
    if (!layer || RM.cartType === 'page') { window.location.href = RM.routes.cart; return; }
    layer.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var x = $('.x', layer); x && x.focus(); }, 10);
  }
  function closeCart() { if (!layer) return; layer.hidden = true; document.body.style.overflow = ''; }

  function applySection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var body = $('#CartDrawerBody', doc), count = $('[data-cart-count-src]', doc);
    if (body) $('#CartDrawerBody').innerHTML = body.innerHTML;
    if (count) setCount(+count.textContent);
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function post(url, data) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw new Error(j.description || j.message || 'Fehler'); } return j; });
    });
  }
  function addItems(items) {
    return post(RM.routes.cartAdd, { items: items, sections: 'cart-drawer' }).then(function (res) {
      if (onCartPage) { window.location.reload(); return; }
      applySection(res.sections && res.sections['cart-drawer']);
      openCart();
    });
  }
  function changeQty(key, qty) {
    return post(RM.routes.cartChange, { id: key, quantity: qty, sections: 'cart-drawer' }).then(function (res) {
      if (onCartPage) { window.location.reload(); return; }
      applySection(res.sections && res.sections['cart-drawer']);
    }).catch(function (e) { toast(e.message); });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && RM.cartType !== 'page' && !onCartPage) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var q = e.target.closest('[data-qty-change]');
    if (q) { e.preventDefault(); q.disabled = true; changeQty(q.dataset.qtyChange, +q.dataset.qty); return; }
    /* Filter-Panels schließen, wenn außerhalb geklickt */
    $$('.fbtn[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && layer && !layer.hidden) closeCart(); });

  /* ---------- Produktformular ---------- */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var hint = form.querySelector('[data-hint]');
      if (!id) {
        if (hint) hint.textContent = 'Bitte zuerst eine Größe wählen.';
        var g = form.querySelector('.sizegrid'); g && g.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var btn = form.querySelector('[type="submit"]');
      btn.setAttribute('aria-busy', 'true');
      var qty = +(form.querySelector('[name="quantity"]') || { value: 1 }).value || 1;
      var items = [{ id: +id, quantity: qty }];
      try {
        var am = form.dataset.anzug ? JSON.parse(form.dataset.anzug) : null;
        if (am && am[id]) {
          var lbl = (form.dataset.anzugName || 'Regenanzug') + ' – Gr. ' + am[id].g;
          items = am[id].t.map(function (t) { return { id: t, quantity: qty, properties: { 'Teil von': lbl } }; });
        }
      } catch (err) {}
      addItems(items)
        .catch(function (err) { if (hint) hint.textContent = err.message; })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  });

  /* Menge +/- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qd]'); if (!b) return;
    var box = b.closest('.qty'), input = $('input', box), label = $('span', box);
    var v = Math.max(1, (+input.value || 1) + (+b.dataset.qd));
    input.value = v; if (label) label.textContent = v;
  });

  /* ---------- Varianten ---------- */
  $$('[data-product-json]').forEach(function (script) {
    var product = JSON.parse(script.textContent);
    var root = script.closest('[data-product]');
    var form = $('form[data-product-form]', root);
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-price]', root);
    var btn = $('[type="submit"]', form);
    var hint = $('[data-hint]', form);
    var picked = (root.dataset.initial ? JSON.parse(root.dataset.initial) : []);

    function find() {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return picked[i] === o; });
      })[0];
    }
    function refreshAvailability() {
      /* Bei einer einzigen Option: ausverkaufte Werte deaktivieren. Sonst: passend zur ersten Wahl. */
      $$('.sz', root).forEach(function (b) {
        var i = +b.dataset.opt, val = b.dataset.value;
        var ok = product.variants.some(function (v) {
          if (!v.available || v.options[i] !== val) return false;
          return v.options.every(function (o, j) { return j === i || !picked[j] || picked[j] === o || product.options.length === 1; });
        });
        b.classList.toggle('unavailable', !ok);
      });
    }
    function update() {
      var v = find();
      $$('.sz', root).forEach(function (b) { b.setAttribute('aria-pressed', picked[+b.dataset.opt] === b.dataset.value); });
      $$('[data-opt-label]', root).forEach(function (el) { el.textContent = picked[+el.dataset.optLabel] || ''; });
      refreshAvailability();
      if (!v) { idInput.value = ''; return; }
      if (hint) hint.textContent = '';
      idInput.value = v.available ? v.id : '';
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    function showMedia(id) {
      var t = $('.thumbs [data-media="' + id + '"]', root);
      if (t) t.click();
    }
    $$('.sz', root).forEach(function (b) {
      b.addEventListener('click', function () { picked[+b.dataset.opt] = b.dataset.value; update(); });
    });
    refreshAvailability();
  });

  /* Galerie */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.thumbs button'); if (!t) return;
    var g = t.closest('.gallery'), main = $('.main img', g);
    $$('.thumbs button', g).forEach(function (x) { x.setAttribute('aria-current', x === t); });
    main.src = t.dataset.src; main.srcset = ''; main.alt = t.dataset.alt || '';
  });

  /* ---------- Filter ---------- */
  $$('form[data-filters]').forEach(function (f) {
    f.addEventListener('change', function (e) {
      if (e.target.matches('[data-price-input]')) return;
      f.submit();
    });
  });

  /* ---------- Größenberater ----------
     Playshoes: fällt großzügig aus, Größe N passt bis Körpergröße N+6 (z. B. 104 für 104/110).
     BMS: normale Passform, Größe = Körpergröße.
     Gummistiefel (Playshoes-Doppelgrößen): Innenlänge = Fußlänge + Zugabe, Schuhgröße = Innenlänge × 1,5. */
  var ADV = {
    sizes: {
      playshoes: { hose: [74, 80, 86, 92, 98, 104, 116, 128, 140, 152], jacke: [74, 80, 86, 92, 98, 104, 116, 128, 140], anzug: [74, 80, 86, 92, 98, 104, 110, 116, 128, 140] },
      bms: { hose: [74, 80, 86, 92, 98, 104, 110, 116, 122, 128, 134, 140, 146, 152], jacke: [74, 80, 86, 92, 98, 104, 110, 116, 122, 128, 134, 140, 146, 152], anzug: [74, 80, 86, 92, 98, 104, 110, 116, 122, 128] }
    },
    room: { playshoes: 6, bms: 0 },
    bmsLeg: { 68: 26, 74: 29, 80: 32, 86: 35, 92: 38, 98: 41, 104: 44, 110: 47, 116: 50, 122: 53, 128: 56, 134: 59, 140: 62, 146: 65, 152: 68 },
    boots: [[18, 19], [20, 21], [22, 23], [24, 25], [26, 27], [28, 29], [30, 31], [32, 33], [34, 35]],
    names: { hose: 'Matschhose', jacke: 'Regenjacke', anzug: 'Regenanzug', stiefel: 'Gummistiefel' },
    brandNames: { playshoes: 'Playshoes', bms: 'BMS' }
  };
  $$('[data-advisor]').forEach(function (a) {
    var cm = $('.cm', a), label = $('[data-adv-label]', a), brandBox = $('[data-adv-brands]', a), extraBox = $('[data-adv-extra]', a);
    var qs = new URLSearchParams(window.location.search);
    var cat = ADV.names[qs.get('art')] ? qs.get('art') : (a.dataset.start || 'hose');
    var brand = qs.get('marke') === 'bms' ? 'bms' : 'playshoes', extra = 0, lastBody = 101, lastFoot = 15, inited = false;
    function press(group, attr, val) { $$('[' + attr + ']', group).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute(attr) === String(val)); }); }
    function renderExtras() {
      var opts = cat === 'stiefel'
        ? [[1.2, 'dünne Socken'], [1.5, 'dicke Socken / Winter']]
        : [[0, 'normal (T-Shirt, Pullover)'], [6, 'über Winteranzug / Schneehose']];
      if (!opts.some(function (o) { return o[0] === extra; })) extra = opts[0][0];
      extraBox.innerHTML = opts.map(function (o) { return '<button type="button" class="chip" data-extra="' + o[0] + '" aria-pressed="' + (o[0] === extra) + '">' + o[1] + '</button>'; }).join('');
    }
    function calc() {
      var v = parseFloat(String(cm.value).replace(',', '.')) || 0, sv = $('.sv', a), why = $('.why', a);
      if (cat === 'stiefel') {
        var inner = v + extra, need = inner * 1.5, hit = null;
        for (var i = 0; i < ADV.boots.length; i++) { if (ADV.boots[i][1] >= need) { hit = ADV.boots[i]; break; } }
        if (!v) { sv.textContent = '–'; why.textContent = 'Fuß auf ein Blatt Papier stellen, Ferse bis längster Zeh messen.'; return; }
        if (!hit) { sv.textContent = '–'; why.textContent = 'Bei ' + v + ' cm Fußlänge ist das größer als unsere Kinder-Gummistiefel (bis 34/35). Schreib uns gern.'; return; }
        sv.textContent = hit[0] + '/' + hit[1];
        why.textContent = 'Fußlänge ' + v + ' cm + ' + String(extra).replace('.', ',') + ' cm Zugabe = ca. ' + inner.toFixed(1).replace('.', ',') + ' cm Innenlänge. Playshoes-Gummistiefel gibt es in Doppelgrößen, ' + hit[0] + '/' + hit[1] + ' passt bis ca. ' + (hit[1] / 1.5).toFixed(1).replace('.', ',') + ' cm Innenlänge.';
        return;
      }
      var list = ADV.sizes[brand][cat], room = ADV.room[brand], needH = v + extra, s = null;
      for (var j = 0; j < list.length; j++) { if (list[j] + room >= needH) { s = list[j]; break; } }
      if (!v) { sv.textContent = '–'; why.textContent = ''; return; }
      if (!s) { sv.textContent = '–'; why.textContent = 'Bei ' + v + ' cm ist die größte ' + ADV.brandNames[brand] + '-Größe (' + list[list.length - 1] + ') zu klein.' + (brand === 'playshoes' ? ' Schau bei BMS, dort gibt es bis 152.' : ''); return; }
      sv.textContent = s;
      var txt = ADV.names[cat] + ' von ' + ADV.brandNames[brand] + ': ';
      txt += brand === 'playshoes'
        ? 'fällt großzügig aus, Größe ' + s + ' passt bei ca. ' + s + '–' + (s + 6) + ' cm Körpergröße.'
        : 'normale Passform, Größe ' + s + ' = bis ' + s + ' cm Körpergröße.';
      if (brand === 'bms' && cat === 'hose' && ADV.bmsLeg[s]) txt += ' Innenbeinlänge ca. ' + ADV.bmsLeg[s] + ' cm.';
      if (extra) txt += ' Eine Nummer größer gerechnet, weil ein Winteranzug darunter kommt.';
      why.textContent = txt;
    }
    function setCat(c) {
      if (inited) { if (cat === 'stiefel') lastFoot = cm.value; else lastBody = cm.value; }
      inited = true;
      cat = c; press(a, 'data-cat', c);
      var boots = c === 'stiefel';
      brandBox.hidden = boots;
      label.textContent = boots ? 'Fußlänge in cm' : 'Körpergröße in cm';
      cm.value = boots ? lastFoot : lastBody;
      renderExtras(); calc();
    }
    a.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !a.contains(b)) return;
      if (b.dataset.cat) { setCat(b.dataset.cat); return; }
      if (b.dataset.brand) { brand = b.dataset.brand; press(brandBox, 'data-brand', brand); calc(); return; }
      if (b.dataset.extra !== undefined) { extra = parseFloat(b.dataset.extra); press(extraBox, 'data-extra', b.dataset.extra); calc(); }
    });
    cm.addEventListener('input', calc);
    press(brandBox, 'data-brand', brand);
    setCat(cat);
  });

  /* ---------- Empfehlungen ---------- */
  $$('[data-recs-url]').forEach(function (el) {
    fetch(el.dataset.recsUrl).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var inner = $('[data-recs-url]', d);
      if (inner && inner.querySelector('.card')) { el.innerHTML = inner.innerHTML; el.hidden = false; }
    }).catch(function () {});
  });

  /* ---------- Kita-Set ---------- */
  $$('[data-set-json]').forEach(function (script) {
    var data = JSON.parse(script.textContent);
    var root = script.closest('[data-set]');
    var pick = data.parts.map(function () { return 0; });
    var sizeSel = $('[data-set-size]', root), shoeSel = $('[data-set-shoe]', root);

    function variantFor(p, size) {
      return p.variants.filter(function (v) { return v.options.indexOf(size) > -1; })[0] || (p.variants.length === 1 ? p.variants[0] : null);
    }
    function uniqSizes(list) {
      var out = [];
      list.forEach(function (s) { if (out.indexOf(s) < 0) out.push(s); });
      return out.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    }
    function fillSelect(sel, sizes) {
      var cur = sel.value;
      sel.innerHTML = sizes.map(function (s) { return '<option' + (s === cur ? ' selected' : '') + '>' + s + '</option>'; }).join('');
      if (!cur && sel.dataset.default && sizes.indexOf(sel.dataset.default) > -1) sel.value = sel.dataset.default;
    }
    function render() {
      var clothes = [], shoes = [];
      data.parts.forEach(function (part, i) {
        var p = part.products[pick[i]];
        p.variants.forEach(function (v) {
          v.options.forEach(function (o) { if (!isNaN(parseFloat(o))) (part.kind === 'shoe' ? shoes : clothes).push(o); });
        });
        var row = $$('.setrow', root)[i];
        var ti = $('.tile img', row); if (ti && p.image && ti.getAttribute('src') !== p.image) { ti.removeAttribute('srcset'); ti.removeAttribute('sizes'); ti.src = p.image; ti.alt = p.title; } $('.tile', row).href = p.url;
        $('h3', row).textContent = p.title;
        $$('.sw', row).forEach(function (s, k) { s.setAttribute('aria-pressed', k === pick[i]); });
      });
      fillSelect(sizeSel, uniqSizes(clothes));
      if (shoeSel) fillSelect(shoeSel, uniqSizes(shoes));
      var sum = 0, off = 0, ok = true;
      data.parts.forEach(function (part, i) {
        var p = part.products[pick[i]];
        var v = variantFor(p, part.kind === 'shoe' ? (shoeSel && shoeSel.value) : sizeSel.value);
        var row = $$('.setrow', root)[i];
        if (!v || !v.available) { ok = false; $('.pr', row).textContent = 'in dieser Größe ausverkauft'; return; }
        sum += v.price; off += Math.floor(v.price * data.discount / 100); $('.pr', row).textContent = money(v.price);
      });
      $('[data-set-sum]', root).textContent = money(sum);
      $('[data-set-off]', root).textContent = '−' + money(off);
      $('[data-set-total]', root).textContent = money(sum - off);
      $('[data-set-warn]', root).hidden = ok;
      $('[data-set-add]', root).disabled = !ok;
    }
    $$('.sw', root).forEach(function (s) {
      s.addEventListener('click', function () { pick[+s.dataset.part] = +s.dataset.k; render(); });
    });
    sizeSel.addEventListener('change', render);
    shoeSel && shoeSel.addEventListener('change', render);
    $('[data-set-add]', root).addEventListener('click', function (e) {
      var btn = e.currentTarget, setId = 'Set-' + Date.now().toString(36);
      var items = data.parts.map(function (part, i) {
        var p = part.products[pick[i]];
        var v = variantFor(p, part.kind === 'shoe' ? (shoeSel && shoeSel.value) : sizeSel.value);
        return { id: v.id, quantity: 1, properties: { _Set: setId } };
      });
      btn.setAttribute('aria-busy', 'true');
      addItems(items).catch(function (err) { toast(err.message); }).then(function () { btn.removeAttribute('aria-busy'); });
    });
    render();
  });

  /* Kontaktformular: erfolgreiche Meldung nach oben scrollen */
  var ok = $('.okmsg:not([hidden])'); ok && ok.scrollIntoView({ block: 'center' });
})();
